import NativeLazyImage from "../component/NativeLazyImage";
import "./../styles/SampleCertificate.style.css";

export default function SampleCertificate() {
  return (
    <section className="bg-light sample-certificate-sec">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-lg-7 d-flex align-items-center">
            <div className="title">
              <h2 className="fw-500">
                Earn an <span className="text-primary">ISO-Certified</span>,{" "}
                <span className="strong">
                  Prestigious Certification from IALM
                </span>
              </h2>

              <p style={{ fontSize: "22px", textAlign: "justify" }}>
                Advance your legal and management career with a{" "}
                <strong className="fw-500">
                  professionally recognised certification from the Indian
                  Academy of Law and Management (IALM){" "}
                </strong>{" "}
                — now an{" "}
                <strong className="fw-500">ISO-certified institution</strong>.
              </p>
              <p className="" style={{ textAlign: "justify" }}>
                Our{" "}
                <strong className="fw-500">
                  industry-recognised, ISO-verified certificates
                </strong>{" "}
                validate your expertise, enhance your professional credibility,
                and open doors to new opportunities in the{" "}
                <strong className="fw-500">
                  legal, corporate, and management sectors
                </strong>
                . Whether you’re a{" "}
                <strong className="fw-500">
                  student, working professional, or corporate executive
                </strong>
                , IALM’s certifications help you stay ahead in today’s
                competitive world.
              </p>
              <p className="" style={{ textAlign: "justify" }}>
                Upon successful completion of any course, you’ll receive a{" "}
                <strong className="fw-500">
                  prestigious digital certificate
                </strong>{" "}
                (hard copy also on request) showcasing your skills, commitment,
                and achievement under IALM’s globally recognised standards.
              </p>

              <p
                className=""
                style={{
                  textAlign: "justify",
                  fontSize: "18px",
                }}
              >
                Take your career to the next level with{" "}
                <strong className="fw-500">
                  IALM Academy — where learning meets excellence.
                </strong>
              </p>
            </div>
          </div>
          <div className="col-md-12 col-lg-5 ">
            <a href="/img/sample-certificate.jpg" target="_blank">
              <NativeLazyImage
                alt="certificate sample"
                src="/img/sample-certificate.jpg"
                classes="certificate-img shadow-lg"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
